import styled, { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import BetsButton from '../Vets/Button';
import { Container, ModalContainer } from '../BaseModal';
import BackButton from '../BackButton';

const LinkText = styled.p`
  color: ${({ theme }) => theme.primary.accent};
  font-family: Manrope;
  font-size: 12px;
  cursor: pointer;
`;

const DepositSelection = () => {
  const navigate = useNavigate();

  const theme = useTheme();

  return (
    <Container>
      <ModalContainer>
        <BackButton />
        <BetsButton
          style={{ background: theme.primary.accent }}
          fullWidth
          onClick={() => {
            navigate('/app/deposit');
          }}
        >
          Deposit with Coinbase
        </BetsButton>
        <BetsButton
          fullWidth
          onClick={() => {
            navigate('/app/deposit/link');
          }}
        >
          Deposit with Stripe
        </BetsButton>
        <LinkText
          style={{ textAlign: 'right' }}
          onClick={async () => {
            navigate('/app/deposit-crypto');
          }}
        >
          Or Deposit Crypto
        </LinkText>
      </ModalContainer>
    </Container>
  );
};

export default DepositSelection;
